import { useEffect, useState } from "react";

import ActiveCallDetail from "./components/ActiveCallDetail";
import Button from "./components/base/Button";
import Vapi from "@vapi-ai/web";
import footerLogo from "../src/Images/superbuter-logo-whiteicon-ai.png";
import { isPublicKeyMissingError } from "./utils";
// import useStayAwake from "use-stay-awake";
// const brightness = require('brightness');
const isProduction = false
// Put your Vapi Public Key below.
//console.log(process.env.REACT_APP_PUBLIC_KEY_DEVELOPMENT); 
// const vapi = isProduction ? new Vapi("385d9875-3247-4aaf-ad82-f07d23de5985") : new Vapi("1c383d43-227f-4cea-b13a-4bf3a24287df");
const vapi = isProduction ? new Vapi("385d9875-3247-4aaf-ad82-f07d23de5985") : new Vapi("47417720-110d-4f62-a29e-c36003ab237a");
//const vapi = isProduction ? new Vapi(process.env.REACT_APP_PUBLIC_KEY_PRODUCTION) : new Vapi(process.env.REACT_APP_PUBLIC_KEY_DEVELOPMENT);

const App = () => {
  const [connecting, setConnecting] = useState(false);
  const [connected, setConnected] = useState(false);

  const [assistantIsSpeaking, setAssistantIsSpeaking] = useState(false);
  const [volumeLevel, setVolumeLevel] = useState(0);
  const [isMuted, setIsMuted] = useState(false);
  
  const { showPublicKeyInvalidMessage, setShowPublicKeyInvalidMessage } = usePublicKeyInvalid();
  // const device = useStayAwake();
  // code for screen timeout starts
  const [wakeLock, setWakeLock] = useState(null);


  const requestWakeLock = async () => {
    if ('wakeLock' in navigator) {
      try {
        const lock = await navigator.wakeLock.request('screen');
        setWakeLock(lock);
        console.log( "Wake Lock active")
        lock.addEventListener('release', () => {
          console.log( "Wake Lock released")
        });
      } catch (err) {
        console.log("Failed to acquire Wake Lock")
      }
    } else {
      console.log("Wake Lock API is not supported in this browser")
    }
  };

  const releaseWakeLock = async () => {
    if (wakeLock) {
      try {
        await wakeLock.release(); // Ensure release completes
        setWakeLock(null); // Clear the state
        console.log('Wake Lock released manually');
      } catch (err) {
        console.log('Error releasing Wake Lock:', err);
      }
    }
  };

  // const handleVisibilityChange = () => {
  //   if (document.visibilityState === 'visible') {
  //      console.log('Tab is active, attempting to reacquire Wake Lock...');
  //     requestWakeLock();
  //   } 
  //   else {
  //     console.log('Tab is inactive');
  //   }
  // };
  // code for screen timeout ends 


  // hook into Vapi events
  useEffect(() => {
    // code for screen timeout
    // requestWakeLock();
    // document.addEventListener('visibilitychange', handleVisibilityChange);
    // code for screen timeout

    //getDataContent();
    vapi.on("call-start", () => {
      setConnecting(false);
      setConnected(true);
      setShowPublicKeyInvalidMessage(false);
      vapi.setMuted(false);
      // vapi.isMuted();
      // device.preventSleeping();
      requestWakeLock();
      if (!wakeLock) {
        console.log('Wake Lock state cleared.');
      }
    //   brightness.get().then(level => {
    //     console.log(level);
    //     //=> 0.5
    // });

    // code for screen timeout
    // return () => {
    //   releaseWakeLock();
    //   document.removeEventListener('visibilitychange', handleVisibilityChange);
    // };
    // code for screen timeout

    }, [wakeLock]);

    vapi.on("call-end", () => {
      setConnecting(false);
      setConnected(false);
      setShowPublicKeyInvalidMessage(false);
    });

    vapi.on("speech-start", () => {
      setAssistantIsSpeaking(true);
    });

    vapi.on("speech-end", () => {
      setAssistantIsSpeaking(false);
    });

    vapi.on("volume-level", (level) => {
      setVolumeLevel(level);
    });

    vapi.on("error", (error) => {
      console.error(error);

      setConnecting(false);
      if (isPublicKeyMissingError({ vapiError: error })) {
        setShowPublicKeyInvalidMessage(true);
      }
    });

  }, []);

  // call start handler
  const startCallInline = () => {
    setConnecting(true);
    // vapi.start( isProduction ? "88ac025d-3e5f-40bd-aee5-0a626c92356c" : "4b1a384e-5ffc-4d0d-a9f3-637ebb6db428");
    vapi.start( isProduction ? "88ac025d-3e5f-40bd-aee5-0a626c92356c" : "9004a260-6184-42ea-8de6-12ec6b4616f8");  //// Working live
    //vapi.start( isProduction ? "d2b88b48-e0e0-486a-924d-ff450068e544" : "9004a260-6184-42ea-8de6-12ec6b4616f8");
    //vapi.start(assistantOptions);
  };
  const endCall = () => {
    vapi.stop();
    releaseWakeLock();
  };
  
  const onUserSpeak = () =>{
    vapi.setMuted(false)
    setIsMuted(false) 
  }
  const onUserMicMute = () =>{
    vapi.setMuted(true)
    setIsMuted(true) 
  }

  return (
    <div className="body-m-wrap flex-1">
      {/* <div style={{ backgroundImage: `url(${wave})` }} className="body-bg-img"></div> */}
     
    <div className="app-p-wrap flex-1">
      <div className="" style={{display:"flex", flexDirection:"column"}}>
    <div className="logo-m-wrap">
        <img src={footerLogo} alt="Logo" />
      </div>
      <div className="voice-ai-text">
        <span>Voice AI Assistant</span>
        <div className="y-b-version">
        <span>Beta</span>
      </div>
      </div>
    <div className="d-margin-cen"
      style={{
        display: "flex",
        // width: "100vw",
        // height: "100vh",
        justifyContent: "center",
        alignItems: "center",
        marginTop:"10px"
      }}
    >
      {!connected ? (
        <Button
          label="Give it a try"
          onClick={startCallInline}
          isLoading={connecting}
          assistantIsSpeaking={false} 
          isMuted={isMuted}
        />
      ) : (
        <ActiveCallDetail
          assistantIsSpeaking={assistantIsSpeaking}
          volumeLevel={volumeLevel}
          onEndCallClick={endCall}
          onUserSpeak={onUserSpeak}
          onUserMicMute={onUserMicMute}
          isMuted={isMuted}
        />
      )}

      {showPublicKeyInvalidMessage ? <PleaseSetYourPublicKeyMessage /> : null}
      {/* <ReturnToDocsLink /> */}
    </div>
    </div>
    <div className='pwrd-by-s-b'>
      {/* <span className="f-b-version">Beta Version</span> */}
      <div className="pwr-sec">
                  <span className='pwrd-by-s-b-i'>Powered by</span>
                  <img height={40} alt="footer" src={footerLogo} />
                  </div>
                </div>
    </div>
    
               
    </div>
  );
};


const usePublicKeyInvalid = () => {
  const [showPublicKeyInvalidMessage, setShowPublicKeyInvalidMessage] = useState(false);

  // close public key invalid message after delay
  useEffect(() => {
    if (showPublicKeyInvalidMessage) {
      setTimeout(() => {
        setShowPublicKeyInvalidMessage(false);
      }, 3000);
    }
  }, [showPublicKeyInvalidMessage]);

  return {
    showPublicKeyInvalidMessage,
    setShowPublicKeyInvalidMessage,
  };
};

const PleaseSetYourPublicKeyMessage = () => {
  return (
    <div
      style={{
        position: "fixed",
        bottom: "25px",
        left: "25px",
        padding: "10px",
        color: "#fff",
        backgroundColor: "#f03e3e",
        borderRadius: "5px",
        boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
      }}
    >
      Is your Vapi Public Key missing? (recheck your code)
    </div>
  );
};

const ReturnToDocsLink = () => {
  return (
    <a
      href="https://docs.vapi.ai"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        top: "25px",
        right: "25px",
        padding: "5px 10px",
        color: "#000",
        textDecoration: "none",
        borderRadius: "5px",
        boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
      }}
    >
      return to docs
    </a>
  );
};

export default App;
